// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { createStructuredSelector } from 'reselect';

// Utils
import { now } from '../../../../../utils/react/propsComparisons';

// Selectors
import getGridSize from '../../../../../utils/grid/gridSizeSelector';

// Actions
import { deselectAllElements } from '../../../../../element/selection/selectionActions';

// Components
import Spinner from '../../../../../components/loaders/Spinner';
import TrashTabContent from '../elementList/TrashTabContent';
import PopupBoardSectionFocusManager from '../../../../../components/popupPanel/PopupBoardSectionFocusManager';
import SelectionMarquee from '../../../../../canvas/selection/SelectionMarquee';
import selectionMarqueeListDecorator from '../../../../../canvas/selection/selectionMarqueeListDecorator';

// Constants
import { ELEMENT_DEFAULT_WIDTH } from '../../../../../../common/elements/elementConstants';

const nowEmpty = now('isEmptyTrash');

const TrashPopupContentComponent = (props) => {
    const { trashFetched, isEmptyTrash, hasMore, PlaceholderComponent } = props;

    if (!trashFetched || (isEmptyTrash && hasMore))
        return (
            <div className="loading-content">
                <Spinner show />
            </div>
        );

    return isEmptyTrash ? <PlaceholderComponent {...props} /> : <TrashTabContent {...props} />;
};

const mapStateToProps = createStructuredSelector({
    gridSize: getGridSize,
});

const mapDispatchToProps = (dispatch) => ({
    dispatchDeselectAll: () => dispatch(deselectAllElements()),
});

@selectionMarqueeListDecorator
@connect(mapStateToProps, mapDispatchToProps)
class TrashPopupGenericTab extends React.Component {
    componentWillMount() {
        const { dispatchFetchTrash, dispatchDeselectAll } = this.props;
        dispatchFetchTrash();
        dispatchDeselectAll();
    }

    componentWillReceiveProps(nextProps) {
        const { trashFetched, hasMore, dispatchLoadMoreTrash } = nextProps;

        // If the trash has become empty, but there's still more trash, then fetch the next page
        if (trashFetched && hasMore && nowEmpty(this.props, nextProps)) {
            dispatchLoadMoreTrash();
        }
    }

    render() {
        const {
            children,
            className,
            isEmptyTrash,
            trashFetched,
            section,
            gridSize,
            trashElementIds,
            setSelectionMarqueeActive,
            setListContainerNode,
            listContainerNode,
        } = this.props;

        const contentClassNames = classNames('content', className, { center: isEmptyTrash || !trashFetched });

        return (
            <div className={contentClassNames}>
                {children}
                <PopupBoardSectionFocusManager
                    section={section}
                    childElementIds={trashElementIds}
                    divRef={setListContainerNode}
                >
                    <SelectionMarquee
                        sectionElementIds={trashElementIds}
                        setSelectionMarqueeActive={setSelectionMarqueeActive}
                        eventListenerNode={listContainerNode}
                        containerWidth={gridSize * (ELEMENT_DEFAULT_WIDTH + 3.9)}
                        gridSize={gridSize}
                    />
                    <TrashPopupContentComponent {...this.props} />
                </PopupBoardSectionFocusManager>
            </div>
        );
    }
}

TrashPopupContentComponent.propTypes = TrashPopupGenericTab.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    className: PropTypes.string,
    section: PropTypes.string.isRequired,
    trashElementIds: PropTypes.array.isRequired,
    hasMore: PropTypes.bool.isRequired,
    hasOlder: PropTypes.bool,
    isEmptyTrash: PropTypes.bool.isRequired,
    trashFetched: PropTypes.bool.isRequired,
    trashFetching: PropTypes.bool.isRequired,
    dispatchFetchTrash: PropTypes.func.isRequired,
    dispatchLoadMoreTrash: PropTypes.func.isRequired,
    dispatchDeselectAll: PropTypes.func,
    PlaceholderComponent: PropTypes.elementType.isRequired,

    gridSize: PropTypes.number,
    setSelectionMarqueeActive: PropTypes.func,
    setListContainerNode: PropTypes.func,
    listContainerNode: PropTypes.object,
};

export default TrashPopupGenericTab;
